import { OrderModel } from "../types/OrderModel";
import { OrderUpdateModel } from "../types/OrderUpdateModel";
import { AssetType } from "../../../shared/types/AssetType";

class OrderMappers {
    mapForEditing(order: OrderModel): OrderUpdateModel {
        return {
            externalId: order.externalId,
            internalId: order.internalId,
            exchangeOrderId: order.exchangeOrderId,
            autoOrderConfiguration: order.autoOrderConfiguration,
            state: order.state,
            targetPlatform: order.targetPlatform,
            type: order.type,
            strike: order.strike,
            expireAt: order.expireAt,
            symbol: order.symbol,
            size: order.size,
            fee: order.fee ?? 0,
            processingType: order.processingType,
            openPrice: order.openPrice,
            markPrice: order.markPrice,
            openedPositionAt: order.openedPositionAt,
            underlyingPriceAtOpen: order.underlyingPriceAtOpen,
            impliedVolatilityAtOpen: order.impliedVolatilityAtOpen,
            delta: order.delta,
            gamma: order.gamma,
            vega: order.vega,
            theta: order.theta,
            comment: order.comment,
            dateForPricing: order.dateForPricing,
            impliedVolatilityForPricing: order.impliedVolatilityForPricing,
            underlyingPriceForPricing: order.underlyingPriceForPricing,
        }
    }

    map(source: OrderUpdateModel, destination: OrderModel): void {
        destination.state = source.state;
        destination.targetPlatform = source.targetPlatform;
        destination.autoOrderConfiguration = source.autoOrderConfiguration;
        destination.size = source.size;
        destination.openPrice = source.openPrice;
        destination.fee = source.fee;
        destination.processingType = source.processingType;
        destination.setChangedState();
        destination.markPrice = source.markPrice;
        destination.type = source.type;
        destination.strike = source.strike;
        destination.expireAt = source.expireAt;
        destination.symbol = source.symbol;
        destination.comment = source.comment;

        destination.openedPositionAt = source.openedPositionAt;
        destination.underlyingPriceAtOpen = source.underlyingPriceAtOpen;
        destination.impliedVolatilityAtOpen = source.impliedVolatilityAtOpen ?? null;

        destination.dateForPricing = source.dateForPricing;
        destination.impliedVolatilityForPricing = source.impliedVolatilityForPricing;
        destination.underlyingPriceForPricing = source.underlyingPriceForPricing;
    }

    getTypeStringValue(type: AssetType): string {
        switch(type) {
            case AssetType.Call:
                return "Call";
            case AssetType.Put:
                return "Put";
            case AssetType.Futures:
                return "Futures";
            case AssetType.Spot:
                return "Spot";
        }
    }

    getType(type: string): AssetType {
        switch(type) {
            case "Call":
                return AssetType.Call;
            case "Put":
                return AssetType.Put;
            case "Futures":
                return AssetType.Futures;
            case "Spot":
                return AssetType.Spot;
            default:
                throw new Error("Some of AssetType value is not supported.");
        }
    }    
    
    getSymbolName(symbol: string, type: AssetType): string {
        if (type === AssetType.Call || type === AssetType.Put)
            return symbol;

        switch (type) {
            case AssetType.Spot:
                return `${symbol} *S`;
            case AssetType.Futures:
                return `${symbol} *F`;
            default:
                throw new Error("Some of AssetType value is not supported.");
        }
    }
}

export const orderMappers = new OrderMappers();
